import { Component, OnInit,Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  selector: 'app-viewuser',
  templateUrl: './viewuser.component.html',
  styleUrls: ['./viewuser.component.scss']
})
export class ViewuserComponent implements OnInit {
  editdata: any;

  constructor(private dialogRef: MatDialogRef<ViewuserComponent>,@Inject(MAT_DIALOG_DATA) private data,public dialog: MatDialog) { }

  ngOnInit(): void {
    this.editdata=this.data
  }
  closeDialog() {
    this.dialogRef.close();
  }
}
